"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = void 0;
class ApiError extends Error {
    constructor(message, statusCode, response, code) {
        super(message);
        this.name = 'ApiError';
        this.statusCode = statusCode;
        this.response = response;
        this.code = code;
    }
}
exports.ApiError = ApiError;
